/**
 * 
 * 线路目标定位
 * zxw
 * 2024-09-20
 */

import { useState,useEffect } from 'react';
import { Input,Row,Col, Button, Space,
    message, Image,
    InputNumber, } from 'antd';
import $ from 'jquery';
import CNF from './incs/Config';
import { winHeight } from './incs/FunHelper';

var lng = '';
var lat = '';
var currentPosition = null; //  当前位置
var watchPositionId = null; //  不断获取坐标任务 

import LOGO from './images/logo.png';
import POLICECAR from './images/police-car-right.gif';

const Aim = () => {
    const [lineAuthorizationCode, setLineAuthorizationCode] = useState('');             //  授权编码
    const [apiKey, setApiKey] = useState('');                   //  接口秘钥
    const [apiSecret, setApiSecret] = useState('');             //  接口密码
    const [useSN, setUseSN] = useState(1);                      //  使用序号
    const [csType, setCSType] = useState('WGS84');              //  坐标类型 
    const [isActive, setIsActive] = useState(false);

    const [longitude, setLongitude] = useState('');     //  经度
    const [latitude, setLatitude] = useState('');       //  纬度

    useEffect(()=>{
        //  获取浏览器地址参数
        let params = new URLSearchParams(window.location.search);
        setLineAuthorizationCode(params.get('lineAuthorizationCode'));
        setApiKey(params.get('apiKey'));
        setApiSecret(params.get('apiSecret'));
        setUseSN(params.get('useSN'));
        window.removeEventListener('beforeunload', handleBeforeUnload);
    },[]);

    /**
     * 退出浏览器
     */
    const handleBeforeUnload = () =>{
        if(watchPositionId){
            cancel();   //  取消任务
        }
    }

    /**
     * 同步经纬度
     * @param {*} position 
     * @param {*} finishReason 
     */
    const sync = (position, finishReason) => {
        //  执行创建
        $.ajax({
            url: `${CNF.api}open/line/aims`,
            headers: {
                'x-api-key': apiKey,
                'x-api-secret': apiSecret
            },
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'line_authorization_code': lineAuthorizationCode,
                'use_sn': useSN,
                'cs_type': csType,
                'longitude': position.coords.longitude,
                'latitude': position.coords.latitude,
                'accuracy': position.coords.accuracy?position.coords.accuracy:0,
                'altitude': position.coords.altitude?position.coords.altitude:0,
                'altitude_accuracy': position.coords.altitudeAccuracy?position.coords.altitudeAccuracy:0,
                'heading': position.coords.heading?position.coords.heading:0,
                'speed': position.coords.speed?position.coords.speed:0,
                'timestamp': position.timestamp?position.timestamp:Date.now(),
                'finish_reason': finishReason,
            }),success:function(data){
                if(data.res === 0){
                    // message.success(data.msg, 1);
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
    }

    /**
     * 获取设备经纬度
     */
    const getLngLat = () => {
        var finishReason = 'start';
        if ('geolocation' in navigator) {
            watchPositionId = navigator.geolocation.watchPosition(function(position){
                //  判断经纬度是否相同，相同则不同步
                //  'start' 时获取经纬度
                //  'end'时获取经纬度
                if(position.coords.longitude !==lng || position.coords.latitude===lat){
                    currentPosition = position;
                    lng = position.coords.longitude;
                    lat = position.coords.latitude;
                    //  与上一次经纬度进行对比
                    if(parseFloat(longitude) !== parseFloat(lng) || parseFloat(latitude) !== parseFloat(lat)){
                        sync(position,finishReason);          //  同步位置
                    }
                    finishReason = 'runing';              //  设置状态为运行中
                    setLongitude(lng);
                    setLatitude(lat);
                }
            }, function(error) {
                message.error('Error Code = ' + error.code + ' - ' + error.message);
            },{
                enableHighAccuracy: true, 
                maximumAge: 500, 
                timeout: 2000
            });
        } else {
            //  geolocation is not supported
            message.error('Geolocation is not supported by this browser.');
        }
    }

    const start = () => {
        if(lineAuthorizationCode === ''){
            message.error('授权编码不能为空！');
            return;
        }
        if(apiKey === '' || apiSecret === ''){
            message.error('接口秘钥不能为空！');
            return;
        }
        setIsActive(true);
        getLngLat();
    }

    const cancel = () => {
        setIsActive(false);             //  取消启动
        navigator.geolocation.clearWatch(watchPositionId);
        sync(currentPosition,'end');    //  结束同步
    }
    return <>
        <div style={{ 
            display: 'flex',
            padding: '0 15%',
            alignItems: 'center', 
            // width: window.screen.width,
            height: winHeight,
            background: '#021629',
        }}>
            <div style={{
                    width: '100%',
                }}>
                    <div style={{textAlign: 'center',color: '#fff'}}><h2>实时定位采集系统</h2></div>
                    <div style={{
                        'height': '50px',
                        textAlign: 'center',
                    }}>
                        <Image width={50} preview={false} src={LOGO}/>
                    </div>
                    <div style={{textAlign: 'center',color: '#fff'}}><p>新致腾科技</p></div>
                {
                    !isActive?<>
                        <Row>
                            <Col span={24}>
                                <Input
                                    onChange={(e)=>{
                                        setLineAuthorizationCode(e.target.value);
                                    }}
                                    placeholder='授权编码'
                                    value={lineAuthorizationCode}
                                    style={{width:'100%',border: 0}}
                                />
                            </Col></Row>
                            <Row style={{ marginTop: 20 }}><Col span={24}>
                                <Input
                                    onChange={(e)=>{
                                        setApiKey(e.target.value);
                                    }}
                                    placeholder='api-key'
                                    value={apiKey}
                                    style={{width:'100%',border: 0}}
                                />
                            </Col></Row>
                            <Row style={{ marginTop: 20 }}><Col span={24}>
                                <Input
                                    onChange={(e)=>{
                                        setApiSecret(e.target.value);
                                    }}
                                    placeholder='api-secret'
                                    value={apiSecret}
                                    style={{width:'100%',border: 0}}
                                />
                            </Col></Row>
                            <Row style={{ marginTop: 20 }}><Col span={24}>
                                <InputNumber
                                    onChange={(value)=>{
                                        setUseSN(value);
                                    }}
                                    placeholder='使用序号'
                                    value={useSN}
                                    style={{width:'100%',border: 0}}
                                />
                            </Col></Row>
                            <Row style={{ marginTop: 20 }}><Col span={24}>
                                <Input
                                    onChange={(e)=>{
                                        setCSType(e.target.value);
                                    }}
                                    placeholder='坐标类型'
                                    value={csType}
                                    style={{width:'100%',border: 0}}
                                />
                            </Col></Row>
                            <Row style={{ marginTop: 20 }}><Col span={24}>
                                <Button
                                    type='primary'
                                    style={{width:'100%',border: 0}}
                                    onClick={()=>{
                                        start();
                                    }}
                                >启动</Button>
                            </Col>
                        </Row>
                    </>
                    :
                    <><Row><Col span={24} style={{ textAlign: 'center', fontSize: 20 }}>
                            <Image preview={false} src={POLICECAR}/>
                        </Col></Row>
                        <Row style={{ marginTop: 20 }}><Col span={24}>
                            <Space.Compact>
                                <Input
                                    style={{
                                        width: '30%',border: 0,background: '#fff',
                                    }}
                                    defaultValue='经度:'
                                    disabled={true}
                                />
                                <Input
                                    style={{
                                    width: '70%',border: 0,background: '#fff',
                                    }}
                                    value={longitude}
                                    disabled={true}
                                />
                            </Space.Compact>
                        </Col></Row>
                        <Row style={{ marginTop: 20 }}><Col span={24}>
                            <Space.Compact>
                                <Input
                                    style={{
                                        width: '30%',border: 0, background: '#fff',
                                    }}
                                    defaultValue='纬度:'
                                    disabled={true}
                                />
                                <Input
                                    style={{
                                    width: '70%',border: 0,background: '#fff',
                                    }}
                                    value={latitude}
                                    disabled={true}
                                />
                            </Space.Compact>
                        </Col></Row>
                        <Row style={{ marginTop: 20 }}><Col span={24}>
                            <Button
                                type='primary'
                                style={{width:'100%',border: 0}}
                                onClick={()=>{
                                    cancel();
                                }}
                            >暂停</Button>
                        </Col></Row>
                    </>
                }
                 <div style={{textAlign: 'center',color: '#fff',fontSize: 13}}>
                    <p style={{ margin:'15px 0 0 5px' }}>湖南新致腾信息科技有限公司</p>
                    <p style={{ margin:0 }}>Copyright @ 2023</p>
                </div>
            </div>
        </div>
    </>
}

export default Aim;